import { useMutation, useQuery } from '@tanstack/react-query'
import { useToast } from '@veracity/vui'
import { useNavigate } from 'react-router-dom'

import { projectsClient } from '@/api'
import { config } from '@/config'

const BASE_ROUTE = '/projects'
const BASE_QUERY_KEY = projectsClient.QUERY_KEY

export const useProjectsList = () => {
  const { showSuccess } = useToast()
  const navigate = useNavigate()

  const projectsQuery = useQuery({
    queryKey: BASE_QUERY_KEY,
    queryFn: projectsClient.getAll,
    refetchInterval: config.requestsConfig.intervals.calculationsStatus
  })

  const addProjectsMutation = useMutation({
    mutationFn: projectsClient.addNewProject,
    onSuccess: (projectId: number) => {
      showSuccess('Project successfully created')
      navigate(`${BASE_ROUTE}/${projectId}`)
    }
  })

  return {
    projects: projectsQuery.data || [],
    isFetching: projectsQuery.isFetching && !projectsQuery.isRefetching,
    addProject: addProjectsMutation.mutate,
    isAddProjectInProgress: addProjectsMutation.isPending
  }
}
